import { render, staticRenderFns } from "./ADTableV2.vue?vue&type=template&id=0fbdfce2&scoped=true&"
import script from "./ADTableV2.vue?vue&type=script&lang=js&"
export * from "./ADTableV2.vue?vue&type=script&lang=js&"
import style0 from "./ADTableV2.vue?vue&type=style&index=0&id=0fbdfce2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbdfce2",
  null
  
)

export default component.exports